import React from "react";

// Asistencia de docentes: unidad = bloque (no sesión), dato de nómina — cuántas
// horas dictó vs. las planificadas. Vive en el mismo tab "Asistencia" que la de
// estudiantes pero en su propia tabla, porque la granularidad no coincide
// (una sesión puede tener varios bloques con distintos docentes/materias).
export default function AsistenciaDocentesTable({ docentes, loading, error, onReintentar }) {
  const porcentajeClase = (pct) => {
    if (pct === null || pct === undefined) return "text-muted";
    if (pct >= 80) return "text-success fw-semibold";
    if (pct >= 60) return "text-warning fw-semibold";
    return "text-danger fw-semibold";
  };

  if (error) {
    return (
      <div className="alert alert-warning d-flex align-items-center justify-content-between management-alert mb-0">
        <div>{error}</div>
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onReintentar}>
          Reintentar
        </button>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="text-center text-muted py-4">
        <span className="spinner-border spinner-border-sm me-2" />
        Cargando asistencia de docentes...
      </div>
    );
  }

  if (!docentes.length) {
    return (
      <p className="text-muted text-center py-4 mb-0">
        Todavía no hay sesiones realizadas con bloques asignados a un docente.
      </p>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-sm table-hover align-middle mb-0">
        <thead className="table-light">
          <tr>
            <th>Docente</th>
            <th>Materia(s)</th>
            <th className="text-center">Bloques dictados</th>
            <th className="text-center">Bloques ausentes</th>
            <th className="text-center">Horas efectivas</th>
            <th className="text-center">% asistencia</th>
          </tr>
        </thead>
        <tbody>
          {docentes.map((d) => (
            <tr key={d.docente_id}>
              <td className="fw-semibold">{d.nombre_completo}</td>
              <td className="text-muted" style={{ fontSize: "0.85rem" }}>{d.materias || "—"}</td>
              <td className="text-center">
                {d.bloques_asistidos} / {d.bloques_planificados}
              </td>
              <td className="text-center">
                {d.bloques_ausentes > 0 ? (
                  <span className="text-danger">{d.bloques_ausentes}</span>
                ) : (
                  <span className="text-muted">0</span>
                )}
              </td>
              <td className="text-center text-muted">
                {d.horas_efectivas} / {d.horas_planificadas} h
              </td>
              <td className={`text-center ${porcentajeClase(d.porcentaje_asistencia)}`}>
                {d.porcentaje_asistencia ?? "—"}
                {d.porcentaje_asistencia !== null && d.porcentaje_asistencia !== undefined ? "%" : ""}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
